<template>
  <a-form
    :form="form"
    @submit.prevent="onSubmit"
    class="form-wrapper"
    layout="vertical"
  >
    <h2>Resetowanie hasła</h2>
    <p>Link resetujący hasło zostanie wysłany na podany adres e-mail.</p>
    <a-form-item label="Adres e-mail" prop="email">
      <a-input
        type="email"
        v-model="form.email"
        auto-complete="off"
        placeholder="adres email"
      >
      </a-input>
    </a-form-item>
    <a-button
      type="primary"
      html-type="submit"
      class="fluid"
      size="large"
      :loading="loading"
    >
      Resetuj hasło
    </a-button>
  </a-form>
</template>

<script>
import { Auth } from '@/api'

export default {
  data() {
    return {
      loading: false,
      form: {}
    }
  },
  methods: {
    redirectOnSuccess() {
      this.$router.push(this.defaultRoute)
    },
    onSubmit() {
      this.loading = true
      let payload = {
        email: this.form.email
      }
      Auth.remind(payload)
        .then(() => {
          this.$emit('formSent')
        })
        .catch(error => {
          let message = 'Wystąpił błąd.'

          if (error.response.data.non_field_errors) {
            message = `${message} ${error.response.data.non_field_errors}`
          }

          this.$message.error(message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.form-wrapper {
  text-align: center;
}
.ant-row.ant-form-item {
  text-align: left;
}

/*.ant-form-item-label {*/
/*  lie*/
/*}*/
</style>
